import { useEffect, useState,} from 'react'; //  useContext
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';

//import { DonneesUtilisateurContext } from '../../contexte.js';
import { apiSoumissionFormulaireDemande } from '../../Datas/datasAutre.js'
import { initialFormData } from '../../Datas/dataCreationCompte.js'


import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import LoadingSpinner from "../../Components/LoadingSpinner";
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';
import HeaderCreaCompte from './HeaderCreaCompte';
import Etape1Siret from './Etape1Siret';
import Etape2QuiformeSuccess from './Etape2QuiformeSuccess';
import Etape2QuiformeFail from './Etape2QuiformeFail';
import Etape3Referent from './Etape3Referent';
import Etape4Antennes from './Etape4Antennes';
import Etape4Lieu from './Etape4Lieu';

import Etape5bQuiformeFail from './Etape5bQuiformeFail';
//import OrganismeListe from './OrganismeListe';



/**
 * Return Formulaire d'inscription
 *
 * @component
 * @summary page d'inscription
 * http://localhost:3000/CreationCompte/OrganismeFormulaire
*/
const OrganismeFormulaire = () => {
  const navigate = useNavigate(); // utile pour changer de page
  //const { utilisateurRouteLogin } = useContext(DonneesUtilisateurContext);

  const [step, setStep] = useState("1"); // 1 4Lieu 5bQuiformeFail...

  const [dataLoaded, setDataLoaded] = useState(true);
  const [spinnerLoad, setSpinnerLoad] = useState(false);
  const [messageProbleme, setMessageProbleme] = useState();

  const [showModalInfo, setShowModalInfo] = useState(false);
  const handleCloseModalInfo = () => setShowModalInfo(false);

  const [messagePourModal, setMessagePourModal] = useState(false);

  const [formData, setFormData] = useState({ ...initialFormData });

  const [organismes, setOrganismes] = useState([]);

  const resetForm = () => {
    setFormData({ ...initialFormData });
    setStep(1);
  };

  const Etape3EnregisterOrganismeEnPacaEtTerminer = async () => { // action à l'étape 3,e x avec : 90132914400025
    try {
      //setOrganismes([...organismes, formData]);
      // resetForm();
      soumetDonneesPourEnregistrement();

    } catch (err) {
      console.error(err);
      alert("Erreur réseau orgF1.");
    }
  };
  const ajouterOrganismeHorsPacaEtinsererNouveauEnPaca  = async () => { // action à l'étape 3
    try {
      setOrganismes([...organismes, formData]);
      setFormData({ ...initialFormData });
      if(global.config.modeDebugApp == 1) console.log('ORAGNISME STORED DANS LE TABLEAU organismes[]');
    
      setStep("4Antennes")
    } catch (err) {
      console.error(err);
      alert("Erreur réseau orgF2.");
    }
  };

  const insererLieu  = async () => { // action à l'étape 3
    try {
      setStep("4Lieu")
    } catch (err) {
      console.error(err);
      alert("Erreur réseau orgF3.");
    }
  };

  const Etape4EnregisterLieuEtTerminer  = async () => { // action à l'étape 4
    try {
      soumetDonneesPourEnregistrement();
    } catch (err) {
      console.error(err);
      alert("Erreur réseau orgF4.");
    }
  };


    const Etape5AJouterAntenneEnPacaGotoListAntennes = async () => { // action à l'étape 3,e x avec : 90132914400025
    try {
      setOrganismes([...organismes, formData]);
      if(global.config.modeDebugApp == 1) console.log('ORAGNISME STORED DANS LE TABLEAU organismes[]');
      setStep("4Antennes")
    } catch (err) {
      console.error(err);
      alert("Erreur réseau Etape5AJouterAntenneEnPacaGotoListAntennes.");
    }
  };
  

   const soumetDonneesPourEnregistrement = async () => {
        try {        
          setMessageProbleme();
          setDataLoaded(false);  
    
          setSpinnerLoad(true);
          var tabOrganisme = []; // pour ici on utilise un tableau local car setOrganismes([...organismes, formData]);  ne met pas à jour organismes (pas de miaj du state, normal)
          tabOrganisme.push(formData);
          var dataR = await apiSoumissionFormulaireDemande("", tabOrganisme, "creation-compte");
          setSpinnerLoad(false);  
             
          if(global.config.modeDebugApp == 1) console.log('retour apiSoumissionFormulaireDemande : ', dataR);
    
          switch (dataR.statusCode) {
              case 200: 
                  setDataLoaded(true);
                  //setShowModalInfo(true)
                  //resetForm(); // Réinitialise le formulaire
                  //setOrganismes([]); // Réinitialise la liste des organismes

                  alert("Votre demande a bien été transmise, nous vérifions l'ensemble des éléments communiqués et revenons vers vous dans les plus brefs délais.");
                  //setStep("1")
                  navigate('/'); //navigate(utilisateurRouteLogin); 
                  break;
              case 401:
                  setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
                  break;
              default:
                  setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
          }             
        } catch (err) {
          console.error(err);
          alert("Erreur réseau F5.");
        }
      };

  //useEffect(() => {  
      //setStep("4Lieu"); // pour test, sinon voir initialisaiton au début, idem
  //}, []);

  useEffect(() => {  
      console.log("OrganismeFormulaire useEffect, organismes : ", organismes);
   /*   if (organismes.length > 0) {
        setStep("4Antennes");
      }*/
  }, [organismes]);
   
  return (

    <div>
        {showModalInfo &&
        <Modal size="lg" show={showModalInfo} onHide={handleCloseModalInfo} backdrop="static" keyboard={false} centered aria-labelledby="m1">
            <Modal.Header closeButton>
            <Modal.Title id="m1">
                Information
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>                
            <div className="bloc-centre">
              <p style={{paddingTop: "20px", fontWeight: "bold"}}>{messagePourModal}</p>
              <div>
                <ButtonDeBase typeSubmit={false} onClick={handleCloseModalInfo} lib="Ok" className2="myside2" className=""  />
              </div>
            </div>
            </Modal.Body>
        </Modal>
        }
      <LoadingSpinner dataLoaded={!spinnerLoad} message="Envoie des informations..."  className="spinner-container3"/>
      <MessageErreurApi message={messageProbleme} />
    <HeaderCreaCompte />
    <div style={{ padding: 20 }}>
      {/*organismes.length === 0 && <p>Aucun organisme ajouté.</p>
      <h2>Ajouter un organisme ({organismes.length} ajouté{organismes.length > 1 ? 's' : ''})</h2>*/}

     

      {step == "1" && (
        <>
          <Etape1Siret
            formData={formData}
            setFormData={setFormData}
            organismes={organismes}
            //onSuccess={() => setStep('')}
            onQuiformeSuccess={() => setStep("2a")}
            onQuiformeFail={() => setStep("2b")}  
          />
        </>
      )}

      {step == "2a" && (
        <Etape2QuiformeSuccess
          formData={formData}
          setFormData={setFormData}
          onPrevious={() => setStep("1")}
          onNext={() => setStep("3")}
        />
      )}
      {step == "2b" && (
        <Etape2QuiformeFail
          formData={formData}
          setFormData={setFormData}
          onPrevious={() => setStep("1")}
        />
      )}

      {step == "3" && (
        <Etape3Referent
          formData={formData}
          setFormData={setFormData}
          onPrevious={() => setStep("2a")}
          ajouterOrganisme={Etape3EnregisterOrganismeEnPacaEtTerminer} //  si dep de paca 
          onCpHorsPacaEtAjoutAntenneAvecCpEnPaca={ajouterOrganismeHorsPacaEtinsererNouveauEnPaca}
          onCpHorsPacaEtAjoutLieu={insererLieu} // si dep hors paca et pas d'antenne déclarée auprès de Kairos différente du siège
        />
      )}

      {step == "4Antennes" && (
        <>
          <Etape4Antennes
            formData={formData}
            setFormData={setFormData}
            organismes={organismes}
            
            setOrganismes = {setOrganismes}
            resetForm = {resetForm}

            onQuiformeSuccess={() => setStep("5aQuiformeSuccess")} // ancien 2a Etape2QuiformeSuccess 5aQuiformeSuccess
            onQuiformeFail={() => setStep("5bQuiformeFail")}   // ancien 2b Etape2QuiformeFail
          />
          {/*
          {organismes.length > 0 && (
            <OrganismeListe
              organismes={organismes}
              setOrganismes = {setOrganismes}
              resetForm = {resetForm}
            />
            
          )}*/}
        </>
      )}

      {step == "4Lieu" && (
        <Etape4Lieu
          formData={formData}
          setFormData={setFormData}
          onPrevious={() => setStep("3")}
          onNext={Etape4EnregisterLieuEtTerminer}
        />
      )}

      {step == "5aQuiformeSuccess" && (
        <Etape2QuiformeSuccess
          formData={formData}
          setFormData={setFormData}
          onPrevious={() => setStep("4Antennes")}
          onNext={() => setStep("5aAfficheReferent")}
        />
      )}



      {step == "5bQuiformeFail" && (
        <Etape5bQuiformeFail
          formData={formData}
          setFormData={setFormData}
          onPrevious={() => setStep("4Antennes")}
          onNext={() => setStep("5aAfficheReferent")}
        />
      )}


       {step == "5aAfficheReferent" && (
        <Etape3Referent
          formData={formData}
          setFormData={setFormData}
          onPrevious={() => setStep("5aQuiformeSuccess")}
          ajouterOrganisme={Etape5AJouterAntenneEnPacaGotoListAntennes} 
        />
      )}
    </div>
    </div>
  );
};

export default OrganismeFormulaire;
